import { useState } from 'react';
import styles from './baseDeCalculoAccordion.module.scss';
import BalnearioDetalhes from './components/balnearioDetalhes/balnearioDetalhes';
import {
  IOperacaoBalnearioResumo,
  IOperacaoReceitaBrutaTributosIncidentesResumo,
  IOperacaoReceitaCalculadaResumo,
  IOperacaoVendaNacionalResumo,
  IOperacaoReceitaExportacoesResumo,
} from '../../../../../../../../interfaces/IOperacoes';
import ReceitaBrutaTributosIncidentesDetalhes from './components/receitaBrutaTributosIncidentesDetalhes/receitaBrutaTributosIncidentesDetalhes';
import VendaNacionalDetalhes from './components/vendaNacionalDetalhes/vendaNacionalDetalhes';
import { ETipoOperacao, OperacaoDetalhe } from '../../../../../../../../enums/ETipoOperacao';
import ReceitaCalculadaDetalhes from './components/receitaCalculadaDetalhes/receitaCalculadaDetalhes';
import ReceitaExportacoesDetalhes from './components/receitaExportacoesDetalhes/receitaExportacoesDetalhes';

interface IBaseDeCalculoAccordionProps {
  baseCalculo: ETipoOperacao;
  listaComponentesBaseCalculoResumo:
    | IOperacaoBalnearioResumo[]
    | IOperacaoReceitaBrutaTributosIncidentesResumo[]
    | IOperacaoVendaNacionalResumo[]
    | IOperacaoReceitaCalculadaResumo[]
    | IOperacaoReceitaExportacoesResumo[];
}

function BaseDeCalculoAccordion({ baseCalculo, listaComponentesBaseCalculoResumo }: IBaseDeCalculoAccordionProps) {
  const [isAccordionOpen, setIsAccordionOpen] = useState<boolean>(false);

  const iconClass: string = !isAccordionOpen ? 'fas fa-angle-down lg' : 'fas fa-angle-up md';

  const tituloFormacaoBaseDeCalculo = OperacaoDetalhe[baseCalculo].label;

  function getResumoDetalhes() {
    switch (baseCalculo) {
      case ETipoOperacao.BALNEARIO:
        return listaComponentesBaseCalculoResumo.map((item, index) => (
          <BalnearioDetalhes key={index} data={item as IOperacaoBalnearioResumo} />
        ));

      case ETipoOperacao.RECEITA_BRUTA_TRIBUTOS_INCIDENTES:
        return listaComponentesBaseCalculoResumo.map((item, index) => (
          <ReceitaBrutaTributosIncidentesDetalhes
            key={index}
            data={item as IOperacaoReceitaBrutaTributosIncidentesResumo}
          />
        ));

      case ETipoOperacao.VENDA_TERRITORIO_NACIONAL_EMPRESAS_COLIGADAS_OU_MESMO_GRUPO_ECONOMICO:
        return listaComponentesBaseCalculoResumo.map((item, index) => (
          <VendaNacionalDetalhes key={index} data={item as IOperacaoVendaNacionalResumo} />
        ));

      case ETipoOperacao.RECEITA_BRUTA_CALCULADA:
        return listaComponentesBaseCalculoResumo.map((item, index) => (
          <ReceitaCalculadaDetalhes key={index} data={item as IOperacaoReceitaCalculadaResumo} />
        ));

      case ETipoOperacao.RECEITA_CALCULADA_EXPORTACOES:
        return listaComponentesBaseCalculoResumo.map((item, index) => (
          <ReceitaExportacoesDetalhes key={index} data={item as IOperacaoReceitaExportacoesResumo} />
        ));

      default:
        return null;
    }
  }

  return (
    <>
      {listaComponentesBaseCalculoResumo && listaComponentesBaseCalculoResumo.length > 0 && (
        <div
          className={styles.accordionItem}
          onClick={() => setIsAccordionOpen(!isAccordionOpen)}
          onKeyDown={() => setIsAccordionOpen(!isAccordionOpen)}
        >
          <button className={styles.button} type='button'>
            <span className={styles.icon}>
              <i className={iconClass} />
            </span>
            <div className={`title ${styles.title}`}>
              <span className={styles.titleDivisor}> Formação Base de Cálculo -</span>
              <span className={styles.titleText}>{tituloFormacaoBaseDeCalculo}</span>
            </div>
          </button>
          {isAccordionOpen && (
            <div className={styles.accordionContent} data-testid='accordion-content'>
              {getResumoDetalhes()}
            </div>
          )}
        </div>
      )}
    </>
  );
}

export default BaseDeCalculoAccordion;
